import { MagnifyingGlass, X } from '@phosphor-icons/react'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'

interface SearchFieldProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

export function SearchField({ value, onChange, className }: SearchFieldProps) {
  const { t } = useTranslation()
  const inputId = useId()

  return (
    <search
      className={`relative min-w-0 ${className ?? ''}`}
      aria-label={t('discovery.search.label')}
    >
      <label htmlFor={inputId} className="sr-only">
        {t('discovery.search.label')}
      </label>
      <MagnifyingGlass
        size={20}
        weight="bold"
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 left-4 -translate-y-1/2 text-muted"
      />
      <input
        id={inputId}
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t('discovery.search.placeholder')}
        autoComplete="off"
        className="min-h-12 w-full rounded-full border border-line bg-white py-2 pr-12 pl-12 text-[17px] outline-none placeholder:text-muted focus-visible:border-teal"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute top-1/2 right-1.5 grid size-9 -translate-y-1/2 place-items-center rounded-full text-muted hover:bg-mint"
        >
          <X size={18} weight="bold" aria-hidden="true" />
          <span className="sr-only">{t('discovery.search.clear')}</span>
        </button>
      ) : null}
    </search>
  )
}
